<template>
  <BfAccordion>
    <template #header-left>
      <BfFlex
        align="center"
        gap="1.6rem"
      >
        <BfIcon
          :icon="icon"
          :size="Sizes.xxl"
          :type="IconType.Contained"
          :contained-padding="Sizes.xxs"
        />

        <h3>{{ title }}</h3>
      </BfFlex>
    </template>

    <template #header-right>
      <BfBadge :color="Colors.Success" />
    </template>

    <slot></slot>
  </BfAccordion>
</template>

<script setup lang="ts">
import {
  BfAccordion,
  BfBadge,
  BfIcon,
  BfFlex,
  Colors,
  IconType,
  Sizes,
} from '@finetic/bikefitting-ui'

defineProps<{
  icon: string
  title: string
}>()
</script>

<style lang="scss"></style>
